<template>
  <form class="mx-auto col-sm-12" @submit.prevent>
    <h3>Contrato</h3>

    <div
      class="row p-2 mb-3"
      style="border: 1px solid #c7c6c6; border-radius: 5px"
    >
      <div class="form-group col-lg-5">
        <label for="contract">{{ $t("contract") }}</label>
        <Combobox
          class="bg-white"
          name="contract"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('contract')"
          :options="contracts"
          :initial-value="vehicle.contract"
          label="contracts"
          v-model="vehicle.contract"
          :reduce="(contract) => contract.id_contrato"
          v-validate="'required'"
        />

        <small v-show="errors.has('contract')" class="form-text text-muted">
          {{ errors.first("contract") }}
        </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('client')"
          :options="clientsByContract"
          :initial-value="vehicle.client"
          label="nome_cliente"
          v-model="vehicle.client"
          :reduce="(client) => client.id"
          v-validate="'required'"
        />

        <small v-show="errors.has('client')" class="form-text text-muted">
          {{ errors.first("client") }}
        </small>
      </div>

      <div
        class="form-group col-lg-3"
        :class="{ 'has-error': errors.has('installation_date') }"
      >
        <label for="installation_date">{{ $t("installation_date") }}</label>
        <input
          type="date"
          id="installation_date"
          name="installation_date"
          class="form-control"
          :placeholder="$t('ph_installation_date')"
          v-model="vehicle.installationDate"
          :hasErrors="errors.has('installation_date')"
          v-validate="'required'"
        />

        <small
          v-show="errors.has('installation_date')"
          class="form-text text-muted"
        >
          {{ errors.first("installation_date") }}
        </small>
      </div>
    </div>

    <h3>Dados</h3>

    <div
      class="row p-2 mb-3"
      style="border: 1px solid #c7c6c6; border-radius: 5px"
    >
      <div
        class="form-group col-lg-4"
        :class="{ 'has-error': errors.has('code') }"
      >
        <label for="code">{{ $t("code") }}</label>
        <input
          type="text"
          id="code"
          name="code"
          class="form-control"
          :placeholder="$t('ph_code')"
          v-model="vehicle.code"
          :hasErrors="errors.has('code')"
          v-validate="'required'"
        />

        <small v-show="errors.has('code')" class="form-text text-muted">
          {{ errors.first("code") }}
        </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="serie">{{ $t("serie") }}</label>
        <Combobox
          class="bg-white"
          name="serie"
          :placeholder="$t('select_a_item')"
          :options="equipments"
          :initial-value="vehicle.serie"
          v-model="vehicle.serie"
        />
      </div>

      <div
        class="form-group col-lg-4"
        :class="{ 'has-error': errors.has('description') }"
      >
        <label for="description">{{ $t("description") }}</label>
        <input
          type="text"
          id="description"
          name="description"
          class="form-control"
          :placeholder="$t('ph_description')"
          v-model="vehicle.description"
          :hasErrors="errors.has('description')"
          v-validate="'required'"
        />

        <small v-show="errors.has('description')" class="form-text text-muted">
          {{ errors.first("description") }}
        </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="vehicle_type">{{ $t("vehicle_type") }}</label>
        <Combobox
          class="bg-white"
          name="vehicle_type"
          :placeholder="$t('select_a_item')"
          label="TPV_DSC"
          :options="vehicleTypes"
          :reduce="(vehicleType) => vehicleType.TPV_ID"
          :initial-value="vehicle.vehicleType"
          v-model="vehicle.vehicleType"
          v-validate="'required'"
          :hasErrors="errors.has('vehicle_type')"
        />

        <small v-show="errors.has('vehicle_type')" class="form-text text-muted">
          {{ errors.first("vehicle_type") }}
        </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="module_model">{{ $t("module_model") }}</label>
        <input
          type="text"
          id="module_model"
          name="module_model"
          class="form-control"
          :placeholder="$t('ph_module_model')"
          v-model="vehicle.chassis"
        />
      </div>

      <div
        class="form-group col-lg-4"
        :class="{ 'has-error': errors.has('board') }"
      >
        <label for="board">{{ $t("board") }}</label>
        <input
          type="text"
          id="board"
          name="board"
          class="form-control"
          :placeholder="$t('ph_board')"
          :value="vehicle.plate"
          v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
          maxlength="8"
          @input="(event) => onChangePlate(event.target.value)"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="brand">{{ $t("brand") }}</label>
        <Combobox
          class="bg-white"
          name="brand"
          :placeholder="$t('select_a_item')"
          :options="vehicleBrands"
          :initial-value="vehicle.brand"
          label="name"
          v-model="vehicle.brand"
          :reduce="(vehicleBrand) => vehicleBrand.name"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="model">{{ $t("model") }}</label>
        <input
          type="text"
          id="model"
          name="model"
          class="form-control"
          :placeholder="$t('ph_model')"
          v-model="vehicle.model"
          @input="upper('model')"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="color">{{ $t("color") }}</label>
        <input
          type="text"
          id="color"
          name="color"
          class="form-control"
          :placeholder="$t('ph_color')"
          v-model="vehicle.color"
          @input="upper('color')"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="year">{{ $t("year") }}</label>
        <Combobox
          class="bg-white"
          name="year"
          :placeholder="$t('select_a_item')"
          :options="years"
          :initial-value="vehicle.year"
          v-model="vehicle.year"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="temperature_sensor">Sensor de Temperatura</label>
        <Combobox
          class="bg-white"
          name="temperature_sensor"
          :placeholder="$t('select_a_item')"
          label="text"
          :options="optionsBoolean"
          :reduce="(temperatureSensor) => temperatureSensor.id"
          :initial-value="vehicle.VEI_SEN_TEMP"
          v-model="vehicle.VEI_SEN_TEMP"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="rfid">RFID</label>
        <Combobox
          class="bg-white"
          name="rfid"
          :placeholder="$t('select_a_item')"
          label="text"
          :options="optionsBoolean"
          :reduce="(rfid) => rfid.id"
          :initial-value="vehicle.VEI_RFID"
          v-model="vehicle.VEI_RFID"
        />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="save" :loading="isLoading">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import years from "@/config/years.js";

export default {
  name: "FinancialVehicleForm",
  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {
      years,
      optionsBoolean: [
        { id: 0, text: "NÃO" },
        { id: 1, text: "SIM" },
      ],
    };
  },

  props: {
    vehicle: {
      type: Object,
      default: () => ({
        id: undefined,
        contract: "",
        client: undefined,
        installationDate: "",
        code: "",
        serie: "",
        description: "",
        vehicleType: "",
        chassis: "",
        plate: "",
        color: "",
        brand: "",
        year: "",
        model: "",
        VEI_SEN_TEMP: 0,
        VEI_RFID: 0,
      }),
    },
  },

  computed: {
    ...mapState({
      contracts: (state) => state.contracts.all,
      isLoading: (state) => state.financial.isLoading,
      clients: (state) => state.financial.clients,
      vehicleTypes: (state) => state.vehicletypes.all,
      vehicleBrands: (state) => state.vehiclebrands.all,
      equipments: (state) => state.arena.equipments,
    }),

    clientsByContract() {
      const contract = this.vehicle.contract;

      if (!contract) {
        return this.clients;
      }

      const contractDataFounded = this.contracts.find(
        (item) => item.id_contrato == contract
      );

      const clientsFromContract = this.clients.filter(
        (client) => client.id == contractDataFounded.id_cliente
      );

      if (clientsFromContract.length === 1) {
        this.vehicle.client = clientsFromContract[0];
      }

      return;
    },
  },

  methods: {
    ...mapActions("financial", [
      "createVehicle",
      "editVehicle",
      "cleanState",
      "clearVehicleById",
    ]),

    async save(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id, client, ...rest } = this.vehicle;

      if (typeof client === "object") {
        rest.client = client.id;
      }

      const result = id
        ? await this.editVehicle({ id, data: rest })
        : await this.createVehicle(rest);

      if (result) {
        this.$router.push({ name: "listfinancialvehicle" });
      }
    },

    upper(attr) {
      this.vehicle[attr] = this.vehicle[attr].toUpperCase();
    },

    onChangePlate(value) {
      if (window.event.inputType === "deleteContentBackward") {
        this.vehicle.plate = value;

        return;
      }

      let finalPLate = value;

      if (value.length === 3) {
        finalPLate = value + "-";
      }

      if (value.length === 4 && !value.includes("-")) {
        finalPLate = value.substr(0, 3) + "-" + value.substr(3);
      }

      this.vehicle.plate = finalPLate.toUpperCase();
    },
  },

  mounted() {
    const { dispatch } = this.$store;

    dispatch("arena/fetchEquipments", {
      withoutVehicle: true,
      vehicleId: this.vehicle.id,
    });
    dispatch("contracts/fetchAllContracts");
    dispatch("financial/fetchClients");
    dispatch("vehicletypes/fetchAll", { excludeNoTracker: false });
    dispatch("vehiclebrands/fetchAll");
  },

  destroyed() {
    this.clearVehicleById()
  },
};
</script>
